// extracted by mini-css-extract-plugin
export default {"formContainer":"IAQInsight2Page_formContainer__mBy0a","resultSection":"IAQInsight2Page_resultSection__NpD8s"};